import { Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";
import CustomLinearProgress from "../../../../Components/Progress/LinearProgress";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from "@material-ui/lab";
import CommentIcon from "@material-ui/icons/Comment";
import ReplyIcon from "@material-ui/icons/Reply";
import CreatedByField from "../../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { formatDate } from "../../../../Helper/MomentHelper";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: "6px 16px",
  },
}));

const PbhWaitingResponseCommentComponent = props => {
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(props.open);
  const classes = useStyles();
  const handleClose = () => {
    setOpen(false);
    props?.handleClose?.();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        {loading ? (
          <CustomLinearProgress loading={loading} periodTime={500} />
        ) : (
          <>
            <DialogTitle id="max-width-dialog-title"></DialogTitle>
            <DialogContent>
              <Timeline align="alternate">
                {props?.record?.remarkList.map((remark, key) => {
                  return (
                    <TimelineItem key={key}>
                      <TimelineOppositeContent>
                        <Typography variant="body2" color="textSecondary">
                          {formatDate(remark?.createdDate)}
                        </Typography>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot>{remark?.isCustomer ? <ReplyIcon /> : <CommentIcon />}</TimelineDot>
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent>
                        <Paper elevation={3} className={classes.paper}>
                          <Typography variant="h6" component="h1">
                            {remark?.isCustomer ? (
                              //@ts-ignore
                              <span class="MuiTypography-root RaReferenceField-link-158 MuiTypography-body2">
                                {remark?.createdBy}
                              </span>
                            ) : (
                              <CreatedByField record={remark} />
                            )}
                          </Typography>
                          <Typography>{remark?.remark}</Typography>
                        </Paper>
                      </TimelineContent>
                    </TimelineItem>
                  );
                })}
              </Timeline>
            </DialogContent>
            <DialogActions></DialogActions>
          </>
        )}
      </Dialog>
    </React.Fragment>
  );
};
export default PbhWaitingResponseCommentComponent;
